// extracted by mini-css-extract-plugin
export default {"content":"productListContainer_content__X1e3K"};